import LText from "@components/LText";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import { MUSIC_ACCESS_FLOW_COPY } from "@libs/shared-ui";

const Unlocked = () => {
  return (
    <Button.Button
      onPress={() => {}}
      sentryEventName="AccessDetail.Unlocked"
      bg="whiteTranslucent20"
    >
      <LIcon colors={{ color: "#FFFFFF80" }} name="lock_unlocked" size={16} />
      <LText variant="Caption/C1/Medium" color="white">
        {MUSIC_ACCESS_FLOW_COPY.unlocked}
      </LText>
    </Button.Button>
  );
};

export default Unlocked;
